import { ScreenProps } from "../../App";
import { useKicktippQuery } from "./queries/useKicktippQuery";
import { teamLogo } from "./teams";
import "./styles/Kicktipp.sass";

const KicktippBuliTableScreen: React.FC<ScreenProps> = ({
  duration,
  christmasTime,
  isActive,
}) => {
  const data = useKicktippQuery();

  if (data.isLoading) return <div>Loading...</div>;

  if (data.isError || !data.data) return <div>Error...</div>;

  const { league_table } = data.data;

  if (!league_table || league_table.length === 0) return <div>Error...</div>;

  return (
    <div className="kicktippScreen">
      <div className="h1">
        <h1><span>9e</span> Buli-Tipp</h1>
      </div>
      <div className="h2"><h2>Bundesliga — Tabelle</h2></div>
      <div className="tableFull">
        <table className="rankingTable buliTable">
          <thead>
            <tr>
              <th className="position">#</th>
              <th className="name">Team</th>
              <th>Sp.</th>
              <th>S</th>
              <th>U</th>
              <th>N</th>
              <th>Tore</th>
              <th>Diff.</th>
              <th>Pkt.</th>
            </tr>
          </thead>
          <tbody>
            {league_table.map((row, index) => (
              <tr
                key={index}
                className={row.position > 0 && row.position <= 4 ? "top" : ""}
              >
                <td className="position">{row.position > 0 ? row.position : ""}</td>
                <td className="name">
                  <span className="teamCell">
                    {teamLogo(row.team) && (
                      <img className="crest" src={teamLogo(row.team)} alt="" />
                    )}
                    {row.team}
                  </span>
                </td>
                <td className="prediction">{row.played}</td>
                <td className="prediction">{row.wins}</td>
                <td className="prediction">{row.draws}</td>
                <td className="prediction">{row.losses}</td>
                <td className="prediction">
                  {row.goals_for}:{row.goals_against}
                </td>
                <td className="prediction">
                  {row.goal_difference > 0 ? `+${row.goal_difference}` : row.goal_difference}
                </td>
                <td className="points">{row.points}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default KicktippBuliTableScreen;
